import React, { useEffect, useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../../firebase';
import './Login.css';

const emailRegex = /^\S+@\S+\.\S+$/;

function mapAuthError(err) {
  const code = err?.code || '';
  switch (code) {
    case 'auth/invalid-email':
      return 'The email address is invalid.';
    case 'auth/user-disabled':
      return 'This user account has been disabled.';
    case 'auth/user-not-found':
      return 'No account found for this email.';
    case 'auth/wrong-password':
      return 'Incorrect password. Please try again.';
    case 'auth/too-many-requests':
      return 'Too many failed login attempts. Please try again later.';
    case 'auth/network-request-failed':
      return 'Network error. Check your internet connection.';
    default:
      return err?.message || 'Failed to sign in.';
  }
}

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [fieldErrors, setFieldErrors] = useState({});
  const [showNotice, setShowNotice] = useState(false);

  useEffect(() => {
    // show the notice only on the login page unless previously acknowledged/declined
    try {
      const seen = localStorage.getItem('welcomeNoticeSeen');
      if (!seen) setShowNotice(true);
    } catch (e) {
      setShowNotice(true);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setFieldErrors({});
    setLoading(true);

    const errors = {};
    if (!email) errors.email = 'Please enter your email address.';
    else if (!emailRegex.test(email)) errors.email = 'Please enter a valid email address.';

    if (!password) errors.password = 'Please enter your password.';
    else if (password.length < 6) errors.password = 'Password must be at least 6 characters.';

    if (Object.keys(errors).length > 0) {
      setFieldErrors(errors);
      setLoading(false);
      return;
    }

    try {
      await signInWithEmailAndPassword(auth, email, password);
      setEmail('');
      setPassword('');
    } catch (err) {
      setError(mapAuthError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      {showNotice && (
        <div className="login-notice-backdrop" role="dialog" aria-modal="true">
          <div className="login-notice">
            <p>
              Dies ist eine interne Seite, die nur für registrierte Benutzer bestimmt ist. Wenn Sie die Dienste dieser Seite nutzen möchten, kontaktieren Sie den Autor: <a href="mailto:ollo7776@gmail.com">ollo7776@gmail.com</a>
            </p>
            <p className="cookie-text">
              Diese Website verwendet Cookies, um die Benutzererfahrung zu verbessern. Durch die Nutzung der Website stimmen Sie der Verwendung von Cookies zu.
            </p>
            <div className="notice-actions">
              <button className="btn-ok" onClick={() => { try { localStorage.setItem('welcomeNoticeSeen', 'ok'); localStorage.setItem('cookieConsent','accepted'); } catch(e){} setShowNotice(false); }}>OK</button>
              <button className="btn-decline" onClick={() => { try { localStorage.setItem('welcomeNoticeSeen', 'declined'); localStorage.setItem('cookieConsent','declined'); } catch(e){} setShowNotice(false); }}>Ablehnen</button>
            </div>
          </div>
        </div>
      )}
      <form className="login-form" onSubmit={handleSubmit} noValidate>
        <h2>Login</h2>

        {error && <div className="login-error">{error}</div>}

        <label htmlFor="email">E-mail</label>
        <input
          id="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          aria-invalid={!!fieldErrors.email}
        />
        {fieldErrors.email && <div className="field-error">{fieldErrors.email}</div>}

        <label htmlFor="password">Password</label>
        <input
          id="password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          aria-invalid={!!fieldErrors.password}
        />
        {fieldErrors.password && <div className="field-error">{fieldErrors.password}</div>}

        <button type="submit" disabled={loading}>
          {loading ? 'Logging in…' : 'Login'}
        </button>
      </form>

      <div className="login-info">
        <h1 className="app-title">Wer - War - Dran</h1>
        <p className="app-desc">Diese Seite dient zur Erfassung erledigter Haushaltsaufgaben, z. B. Spülmaschine, Küche, Waschmaschine oder Trockner. Jeder Benutzer markiert, was er erledigt hat, und alle Informationen werden übersichtlich angezeigt.</p>
      </div>
    </div>
  );
}
